
import MultiplePhonePicker from "../../../components/form-components/MultiplePhonePicker.vue";
import DatePicker from "../../../components/form-components/DatePicker.vue";
import Vue from "vue";
import FileUploader from "@/components/form-components/FileUploader.vue";
import PhonePicker from "@/components/form-components/PhonePicker.vue";
import store from "@/store";
import API from "@/api/API";
import { APPLICATION_STATUSES } from "@/static/constants";
import ConfirmTrustedDataDialog from "@/modules/applications/dialogs/ConfirmTrustedDataDialog.vue";
import SuccessfulSubmit from "@/modules/applications/dialogs/SuccessfulSubmit.vue";
import { timeToEnd } from "@/config/registrationWindow";

export default Vue.extend({
  name: "General",

  components: {
    SuccessfulSubmit,
    ConfirmTrustedDataDialog,
    FileUploader,
    DatePicker,
    MultiplePhonePicker,
    PhonePicker,
  },

  data: () => ({
    APPLICATION_STATUSES,
    model: {
      application: {} as any,
      application_study_types: [] as Array<any>,
      need_hostel: false as boolean,
      abiturient: {
        has_driving_license: false as boolean,
        is_married: false as boolean,
      } as any,
      abiturient_contacts: [] as Array<any>,
      graduated_university: {} as any,
      scientific_publications: [{} as any] as Array<any>,
      documents: [{} as any] as Array<any>,
      abiturient_documents: [{ type: "diplom_copy" } as any] as Array<any>,
      family_members: {
        mother: { role: "mother" } as any,
        father: { role: "father" } as any,
        husband: { role: "husband", home_phone: null } as any,
        wife: { role: "wife", home_phone: null } as any,
        children: [{ role: "child" } as any] as Array<any>,
      } as any,
      foreign_languages: [{} as any] as Array<any>,
      sex: [{} as any] as Array<any>,
      rh: [{} as any] as Array<any>,
      residence_medium: [{} as any] as Array<any>,
      blood_type: [{} as any] as Array<any>,
      obtained_title: [{} as any] as Array<any>,
      required_documents: {} as any,
    } as any,
    requiredDocuments: {} as any,
    loading: false as boolean,
    showTrustDialog: false as boolean,
    showSuccessfulSubmitDialog: false as boolean,
    timeToEnd,
  }),

  computed: {
    optionalDocuments() {
      return (
        this.model.abiturient_documents?.filter((item: any) =>
          item.type.startsWith("optional_copy_")
        ) || []
      );
    },
    badgeColor() {
      return this.model.application?.status?.color;
    },
    language() {
      return this.$store.getters["localization/getCurrent"];
    },
    isWaiting() {
      return (
        this.model.application?.status?.alias === APPLICATION_STATUSES.awaiting
      );
    },
    isConfirmed() {
      return (
        this.model.application?.status?.alias === APPLICATION_STATUSES.confirmed
      );
    },
    blocked() {
      return !this.isTimeToEnd();
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.applications().preview();

      next((vm) => {
        if (
          ["admin", "operator"].includes(
            vm.$store.getters["user/info"].role.name
          )
        ) {
          vm.$router.push("/application_requests");
          return;
        }

        /*let familyMembers = {
          children: [] as Array<any>,
        } as any;

        /*for (const member of item.family_members) {
          if (member.role === "child") {
            familyMembers.children.push(member);
          } else {
            familyMembers[member.role] = member;
          }
        }*/

        /*familyMembers.children = familyMembers.children.filter(
          (item: any) => item.birthday && item.full_name
        );*/

        // item.family_members = { ...vm.model.family_members, ...familyMembers };

       /* item.application_study_types = item.application_study_types
          .map((item: string) =>
            vm.$t(`applications.form.application.finance_type.${item}`)
          )
          .join(",");*/
        for (const document of item.abiturient_documents) {
          if (!document.type.startsWith("optional_copy_")) {
            vm.requiredDocuments[document.type] = document;
          }
        }

        vm.model = item;

        vm.$nextTick(() => {
          vm.fullLoaded = true;
          vm.$forceUpdate();
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    isTimeToEnd() {
      return new Date() < new Date(this.timeToEnd);
    },
    edit(): void {
      this.$router.push(`/application/edit/${this.model.application.id}`);
    },
    async send(): Promise<void> {
      this.loading = true;
      try {
        await this.$API
          .applications()
          .abiturientConfirm(this.model.application.id);

        this.showSuccessfulSubmitDialog = true;
      } catch (e) {
        await store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    async downloadFile(file: any) {
      if (file) {
        const element = document.createElement("a");
        element.setAttribute("href", file.url);
        element.setAttribute("download", file.name);
        element.setAttribute("target", "_blank");
        element.click();
      }
    },
  },
});
